import React, { useEffect, useState, useMemo } from "react";
import { useObjectivesList } from "../../../../hooks/useObjectivesList";
import AtSelectPeriod from "../../../../components/AtSelectPeriod/AtSelectPeriod";
import moment from "moment-timezone";
import "moment/locale/es";
import {
    createSelectedPeriodState,
    defaultPeriodsGeneralStatus,
} from "../../../../utils/fns/generate-period-state";
import {
    Box,
    Dialog,
    Grid,
    IconButton,
    LinearProgress,
    Typography,
    Switch,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Badge,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Select,
    MenuItem,
    Chip,
    FormControl,
    Checkbox,
    ListItemText,
    TextField,
    Snackbar
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { FilterTags } from "../../../../components/TagsAtentus/FilterTags";
import { Alert } from "@material-ui/lab";
import ListObjectiveModal from "../../../Dashboard/components/ListObjectiveModal";
import UpdateIcon from "@material-ui/icons/Update";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import EventNoteIcon from "@material-ui/icons/EventNote";
import DeleteIcon from "@material-ui/icons/Delete";
import { useInterval } from "../../../../hooks/useInterval";
import { ConfigPopover } from "./ConfigPopover";
import { ObjectiveZoomGraph } from "./ObjectiveZoomGraph";
import { getDetalleDisponibilidadParcialObjetivoDowntime } from "../../../../services/getObjectives/get-objectives-status";
import { filterObjectivesByTags } from "../../../../utils/tags";
import queryString from "query-string";
import { COLORS } from "../../../../utils/colors";
import { useTranslation } from "react-i18next";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import Tooltip from '@material-ui/core/Tooltip';
import ClearIcon from '@material-ui/icons/Clear';
import {createMaintenance} from '../../../../services/createMaintenance'
import {getValidateMaintenance} from '../../../../services/getValidateMaintenance';

// Helper defensivo para garantizar siempre un arreglo y evitar "list.map is not a function"
function extractArray(data) {
    if (Array.isArray(data)) return data;
    if (data && typeof data === "object") {
        if (Array.isArray(data.data)) return data.data;
        if (Array.isArray(data.objectives)) return data.objectives;
        if (Array.isArray(data.listaData)) return data.listaData;
        if (Array.isArray(data.list)) return data.list;
    }
    return [];
}

function getSeries(externalDataConsolidated, index, isSpecial, t) {
    const { estado } = externalDataConsolidated.Objetivo.Nodo[0];

    let dictDataStackedBarUptime = { name: "Uptime", pointWidth: 10 };
    let arrayDataUptime = [];

    let dictDataStackedBarDowntime = { name: "Downtime", pointWidth: 10 };
    let arrayDataDowntime = [];

    let dictDataStackedBarNoMon = { name: "No Monitoreo", pointWidth: 10 };
    let arrayDataNoMon = [];

    let dictDataStackedBarPartial = { name: "Downtime Parcial", pointWidth: 10 };
    let arrayDataPartial = [];

    let dictDataStackedBarEventoCliente = { name: "Evento Cliente", pointWidth: 10 };
    let arrayDataEventoCliente = [];

    let dictDataStackedBarMarcadoAtentus = { name: "Marcado Atentus", pointWidth: 10 };
    let arrayDataMarcadoAtentus = [];

    Object.keys(estado).forEach((key) => {
        let dictDataStackedBar = {};

        let dateJson = new Date(estado[key]["fecha_desde"].substring(0, 19));
        let year = dateJson.getFullYear();
        let month = dateJson.getMonth();
        let day = dateJson.getDate();
        let hours = dateJson.getHours();
        let minutes = dateJson.getMinutes();
        let seconds = dateJson.getSeconds();

        let dateJsonEnd = new Date(estado[key]["fecha_hasta"].substring(0, 19));
        let yearEnd = dateJsonEnd.getFullYear();
        let monthEnd = dateJsonEnd.getMonth();
        let dayEnd = dateJsonEnd.getDate();
        let hoursEnd = dateJsonEnd.getHours();
        let minutesEnd = dateJsonEnd.getMinutes();
        let secondsEnd = dateJsonEnd.getSeconds();

        dictDataStackedBar["x"] = Date.UTC(year, month, day, hours, minutes, seconds);
        dictDataStackedBar["x2"] = Date.UTC(yearEnd, monthEnd, dayEnd, hoursEnd, minutesEnd, secondsEnd);
        dictDataStackedBar["y"] = index;

        if (isSpecial) {
            if (estado[key]['nombre'] === 'uptime') {
                if (arrayDataUptime.length) {
                    let lastUptime = arrayDataUptime[arrayDataUptime.length - 1];
                    if (lastUptime['x2'] === dictDataStackedBar['x']) {
                        lastUptime['x2'] = dictDataStackedBar['x2'];
                        arrayDataUptime[arrayDataUptime.length - 1] = lastUptime;
                    } else {
                        dictDataStackedBar['color'] = COLORS.UPTIME;
                        arrayDataUptime.push(dictDataStackedBar);
                    }
                } else {
                    dictDataStackedBar['color'] = COLORS.UPTIME;
                    arrayDataUptime.push(dictDataStackedBar);
                }
            } else if (estado[key]['nombre'] === 'downtime') {
                dictDataStackedBar['color'] = COLORS.DOWNTIME;
                arrayDataDowntime.push(dictDataStackedBar);
            } else if (estado[key]['nombre'] === 'no monitoreo') {
                dictDataStackedBar['color'] = COLORS.NO_MONITOREO;
                arrayDataNoMon.push(dictDataStackedBar);
            } else if (estado[key]['nombre'] === 'downtime parcial') {
                if (Number(key) > 0 && estado[Number(key) - 1].nombre === 'uptime') {
                    let lastUptime = arrayDataUptime.pop();
                    lastUptime['x2'] = dictDataStackedBar['x2'];
                    arrayDataUptime.push(lastUptime);
                } else {
                    dictDataStackedBar['color'] = COLORS.UPTIME;
                    arrayDataUptime.push(dictDataStackedBar);
                }
            } else if (estado[key]['nombre'] === 'evento cliente') {
                dictDataStackedBar['color'] = COLORS.EVENTO_CLIENTE;
                arrayDataEventoCliente.push(dictDataStackedBar);
            } else if (estado[key]['nombre'] === 'marcado atentus') {
                dictDataStackedBar['color'] = COLORS.MARCADO_ATENTUS;
                arrayDataMarcadoAtentus.push(dictDataStackedBar);
            }
        } else {
            if (estado[key]['nombre'] === 'uptime') {
                dictDataStackedBar['color'] = COLORS.UPTIME;
                arrayDataUptime.push(dictDataStackedBar);
            } else if (estado[key]['nombre'] === 'downtime') {
                dictDataStackedBar['color'] = COLORS.DOWNTIME;
                arrayDataDowntime.push(dictDataStackedBar);
            } else if (estado[key]['nombre'] === 'no monitoreo') {
                dictDataStackedBar['color'] = COLORS.NO_MONITOREO;
                arrayDataNoMon.push(dictDataStackedBar);
            } else if (estado[key]['nombre'] === 'downtime parcial') {
                dictDataStackedBar['color'] = COLORS.DOWNTIME_PARCIAL;
                arrayDataPartial.push(dictDataStackedBar);
            } else if (estado[key]['nombre'] === 'evento cliente') {
                dictDataStackedBar['color'] = COLORS.EVENTO_CLIENTE;
                arrayDataEventoCliente.push(dictDataStackedBar);
            } else if (estado[key]['nombre'] === 'marcado atentus') {
                dictDataStackedBar['color'] = COLORS.MARCADO_ATENTUS;
                arrayDataMarcadoAtentus.push(dictDataStackedBar);
            }
        }
    });

    dictDataStackedBarUptime["data"] = arrayDataUptime;
    dictDataStackedBarDowntime["data"] = arrayDataDowntime;
    dictDataStackedBarNoMon["data"] = arrayDataNoMon;
    dictDataStackedBarPartial["data"] = arrayDataPartial;
    dictDataStackedBarEventoCliente["data"] = arrayDataEventoCliente;
    dictDataStackedBarMarcadoAtentus["data"] = arrayDataMarcadoAtentus;

    dictDataStackedBarUptime.name = t('general-status.graph.status.uptime');
    dictDataStackedBarDowntime.name = t('general-status.graph.status.downtime');
    dictDataStackedBarPartial.name = t('general-status.graph.status.partial-downtime');
    dictDataStackedBarNoMon.name = t('general-status.graph.status.no-monitoring');
    dictDataStackedBarEventoCliente.name = t('general-status.graph.status.client-event');
    dictDataStackedBarMarcadoAtentus.name = t('general-status.graph.status.downtime');

    const consolidatedData = {
        obj: externalDataConsolidated.Objetivo,
        uptime: dictDataStackedBarUptime,
        down: dictDataStackedBarDowntime,
        noMon: dictDataStackedBarNoMon,
        parcial: dictDataStackedBarPartial,
        eventoCliente: dictDataStackedBarEventoCliente,
        marcadoCliente: dictDataStackedBarMarcadoAtentus,
    };

    const detailIndividualData = [
        dictDataStackedBarUptime,
        dictDataStackedBarDowntime,
        dictDataStackedBarNoMon,
        dictDataStackedBarPartial,
        dictDataStackedBarEventoCliente,
        dictDataStackedBarMarcadoAtentus,
    ];

    return { detailIndividualData, consolidatedData };
}

const INTERVAL = 300000;
const autoRefreshSaved = localStorage.getItem("autoRefreshNewGeneralStatus");
const autoRefreshSavedValue = Number(autoRefreshSaved) || null;
const CLIENT_BBVA_AR = '5467';
const email = sessionStorage.getItem('email');

function getListData() {
    let data = null;
    if (sessionStorage.getItem("listsLoads") === "true") {
        try {
            data = JSON.parse(sessionStorage.getItem("listaData"));
        } catch (e) {
            data = null;
        }
    }
    return data;
}

export function PanelAvailabilityCopy({
    filterType,
    etiquetas,
    selectedPeriodState,
    active,
}) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [apiData, setApiData] = useState(null);
    const [filterTagsType, setFilterTagsType] = useState(filterType);
    const [filterTagsId, setFilterTagsId] = useState(etiquetas);
    const [periodState, setPeriodState] = useState(selectedPeriodState);
    const [activePeriodState] = useState(active);

    const [dataModal, setDataModal] = useState({
        open: false,
        objId: null,
        objNameModal: null,
    });

    const [pendingEventData, setPendingEventData] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [storedEvents, setStoredEvents] = useState([]);
    const [scheduleModalOpen, setScheduleModalOpen] = useState(false);

    const [configEl, setConfigEl] = useState(null);
    const [autoRefresh, setAutoRefresh] = useState(autoRefreshSavedValue || INTERVAL);
    const [lastUpdate, setLastUpdate] = useState(new Date());

    const {
        data: objectives,
        isLoading: isLoadingObjectives,
    } = useObjectivesList({ fromStorage: true });
    const [objectivesListData] = useState(getListData());
    const [isGlobal] = useState(sessionStorage.getItem("client_id") === CLIENT_BBVA_AR);
    const [isSpecial, setIsSpecial] = useState(sessionStorage.getItem("client_id") === CLIENT_BBVA_AR);
    const [scheduleError, setScheduleError] = useState(null);

    const availableObjectivesList = useMemo(() => {
        const objArray = extractArray(objectives);
        const listDataArray = extractArray(objectivesListData);
        const list = objArray.length > 0 ? objArray : listDataArray;
    
        return list
            .map((o) => {
                if (typeof o === "string") {
                    return { objetivo_id: null, nombre: o };
                }
    
                const nombre = o?.nombre || o?.objetivo_nombre || o?.nombre_objetivo || "";
                const objetivo_id = o?.objetivo_id || o?.id || o?.id_objetivo || null;
    
                return {
                    objetivo_id,
                    nombre,
                };
            })
            .filter((item) => Boolean(item.nombre));
    }, [objectives, objectivesListData]);

    useInterval(() => {
        processData();
    }, autoRefresh);

    const [dataModalFullscreen, setDataModalFullscreen] = useState({
        fullScreenEl: false,
    });

    const processData = React.useCallback(async () => {
        setIsLoading(true);
        try {
            const safeObjList = extractArray(objectives);
            const data = await getDetalleDisponibilidadParcialObjetivoDowntime(
                safeObjList,
                periodState
            );
            const objectivesGraphData = (data || []).filter(
                (item) => item?.Objetivo?.Nodo[0]?.estado?.length
            );
            setApiData(objectivesGraphData);
        } catch (err) {
            console.error("Error al cargar los datos");
        } finally {
            setIsLoading(false);
            setLastUpdate(new Date());
        }
    }, [objectives, periodState]);

    useEffect(() => {
        if (!isLoadingObjectives) {
            processData();
        }
    }, [isLoadingObjectives, processData]);

    const graphData = React.useMemo(() => {
        if (!apiData) return null;
        const graphDataFilteredByTags = filterObjectivesByTags({
            filterTagsId,
            filterTagsType,
            objectives: apiData,
        }).map((objetivo, index) => {
            const series = getSeries(objetivo, index, isSpecial, t);
            objetivo.data = series.consolidatedData;
            objetivo.detailIndividualData = series.detailIndividualData;
            return objetivo;
        });
    
        // Ahora cada elemento de categories contiene tanto el ID como el nombre
        const categories = graphDataFilteredByTags.map((item) => ({
            objetivo_id: item.objetivo_id || item.id || item.id_objetivo || null,
            nombre: item.nombre,
        }));
    
        const series = graphDataFilteredByTags.flatMap(
            (item) => item.detailIndividualData
        );
        return { categories, series };
    }, [apiData, filterTagsId, filterTagsType, isSpecial, t]);

    function changeGlobalPeriod({ period, statePeriod }) {
        const newSelectedPeriodState = createSelectedPeriodState(
            period,
            0,
            statePeriod
        );
        setPeriodState(newSelectedPeriodState);

        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed["periodo"] = period;
        if (period === "c") {
            const startDate = statePeriod && moment(statePeriod.startDate).format("YYYY-MM-DD");
            const endDate = statePeriod && moment(statePeriod.endDate).format("YYYY-MM-DD");
            queryParamsParsed["startDate"] = startDate;
            queryParamsParsed["endDate"] = endDate;
        } else {
            delete queryParamsParsed["startDate"];
            delete queryParamsParsed["endDate"];
        }

        window.history.replaceState(
            null,
            "Estado General",
            `/generalStatus?${queryString.stringify(queryParamsParsed)}`
        );
    }

    function updateEtiquetas(etiquetas, type) {
        const ids = etiquetas.map((etiqueta) => etiqueta.etiqueta_id);
        setFilterTagsId(ids);
        setFilterTagsType(type);

        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed["filterType"] = type;
        queryParamsParsed["etiquetas"] = ids.join("T");

        window.history.replaceState(
            null,
            "Estado General",
            `/generalStatus?${queryString.stringify(queryParamsParsed)}`
        );
    }

    function openModal(category) {
        if (!category) return;
        
        const objArray = extractArray(objectives);
        const listDataArray = extractArray(objectivesListData);
        const listToSearch = objArray.length > 0 ? objArray : listDataArray;
        
        const targetName = String(category).trim().toLowerCase();

        const objective = listToSearch.find((o) => {
            const name = typeof o === "string" ? o : (o?.nombre || o?.objetivo_nombre || o?.nombre_objetivo || "");
            return name.trim().toLowerCase() === targetName;
        });

        const foundId = objective ? (objective.objetivo_id || objective.id || objective.objetivoId) : null;

        setDataModal({
            open: true,
            objId: foundId,
            objNameModal: category,
        });
    }

    function handleCloseModal() {
        setDataModal({
            open: false,
            objId: null,
            objNameModal: null,
        });
    }

    function handleCloseFullScreen() {
        setDataModalFullscreen({ fullScreenEl: false });
    }

    const handleSelectEvent = (eventData) => {
        setPendingEventData(eventData);
        setConfirmDialogOpen(true);
    };

    const handleConfirmSelection = () => {
        if (pendingEventData) {
            setStoredEvents((prev) => [...prev, pendingEventData]);
        }
        setConfirmDialogOpen(false);
        setPendingEventData(null);
    };

    const handleCancelSelection = () => {
        setConfirmDialogOpen(false);
        setPendingEventData(null);
    };

    const handleDeleteStoredEvent = (id) => {
        setStoredEvents((prev) => prev.filter((item) => item.id !== id));
    };

    const handleObjectivesChangeForEvent = (eventId, selectedObjectives) => {
        // Garantizamos que selectedObjectives sea un arreglo
        const rawValues = typeof selectedObjectives === 'string' 
            ? selectedObjectives.split(',') 
            : selectedObjectives;
    
        // Filtramos duplicados comparando id o nombre (en caso de que MUI repita referencias)
        const uniqueObjectives = rawValues.reduce((acc, current) => {
            const isDuplicate = acc.some(
                (item) =>
                    (item.objetivo_id && item.objetivo_id === current.objetivo_id) ||
                    (item.nombre && item.nombre === current.nombre)
            );
            if (!isDuplicate) acc.push(current);
            return acc;
        }, []);
    
        setStoredEvents((prev) =>
            prev.map((item) =>
                item.id === eventId ? { ...item, objetivos: uniqueObjectives } : item
            )
        );
    };
    const [loadModal, setLoadModal] = useState(false);
    const [check, setCheck] = useState(false);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setLoadModal(false);
    };

    const lastUpdateFormat = moment(lastUpdate)
        .tz(sessionStorage.getItem("tz") || moment.tz.guess())
        .format("DD/MM/YYYY, h:mm:ss a");

    function handleChangeAutoRefresh(event) {
        const newValue = !Boolean(event.target.value === "true");
        setAutoRefresh(newValue ? INTERVAL : null);
    }

    const handleChangeSwitch = (event) => {
        setIsSpecial(event.target.checked);
    };

    const handleFieldChangeForEvent = (id, field, value) => {
        setStoredEvents((prevEvents) =>
            prevEvents.map((item) =>
                item.id === id ? { ...item, [field]: value } : item
            )
        );
    };

    const handleProcessSchedule = async () => {
        const token = sessionStorage.getItem("key");
        const user=(sessionStorage.getItem("user"))
        const nameUser=(sessionStorage.getItem("user_name"))
    
        setScheduleError(null);
    
        if (storedEvents.length === 0) return;
    
        // Mapeo de errores con i18next t()
        const errorKeys = [
            'schedule.errors.no_date',            // Index 0
            'schedule.errors.missing_params',     // Index 1
            'schedule.errors.bad_time_format',    // Index 2
            'schedule.errors.bad_time_range',     // Index 3
            'schedule.errors.no_objectives',      // Index 4
            'schedule.errors.end_before_start'    // Index 5
        ];
    
        // Validación de cada caso almacenado
        for (const item of storedEvents) {
            const startMoment = moment(item.fechaInicio);
            const endMoment = moment(item.fechaFin);
    
            // Index 0: schedule.errors.no_date
            if (!item.fechaInicio || !item.fechaFin) {
                setScheduleError(t(errorKeys[0]));
                return;
            }
    
            // Index 1: schedule.errors.missing_params (faltan campos requeridos como título)
            if (!item.titulo || !item.titulo.trim()) {
                setScheduleError(t(errorKeys[1]));
                return;
            }
    
            // Index 2: schedule.errors.bad_time_format
            if (!startMoment.isValid() || !endMoment.isValid()) {
                setScheduleError(t(errorKeys[2]));
                return;
            }
    
            // Index 3: schedule.errors.bad_time_range (inicio y fin son exactamente iguales)
            if (startMoment.unix() === endMoment.unix()) {
                setScheduleError(t(errorKeys[3]));
                return;
            }
    
            // Index 4: schedule.errors.no_objectives
            if (!item.objetivos || item.objetivos.length === 0) {
                setScheduleError(t(errorKeys[4]));
                return;
            }
    
            // Index 5: schedule.errors.end_before_start (inicio es posterior a la fecha fin)
            if (startMoment.isAfter(endMoment)) {
                setScheduleError(t(errorKeys[5]));
                return;
            }
        }
    
        setIsLoading(true);
    
        try {
            for (const item of storedEvents) {
                const newObjetivos = item.objetivos
                    .map((o) => o.objetivo_id)
                    .filter(Boolean);
                
                const begin = moment.utc(item.fechaInicio).format("YYYY-MM-DD HH:mm:ss");
                const final = moment.utc(item.fechaFin).format("YYYY-MM-DD HH:mm:ss");
                const comment = item.comentario || "";
                const titulo = item.titulo || "";
        
                // 1. Validar cruzamiento con otros mantenimientos
                const validateData = await getValidateMaintenance(user, token, begin, final, newObjetivos, 0);
                
                if (validateData && validateData.length > 0) {
                    const objetivos = item.objetivos;
                    const nombresObjetivos = validateData
                        .map((item) => {
                            const objEncontrado = objetivos.find((o) => o.objetivo_id === item.objetivo_id);
                            return objEncontrado ? objEncontrado.nombre : null;
                        })
                        .filter(Boolean);
                
                    const objetivosUnicos = [...new Set(nombresObjetivos)].join(', ');
                    const textoObjetivos = objetivosUnicos ? ` [${objetivosUnicos}]` : '';
                    const mensajeError = `${t('schedule.errors.overlap') || 'Conflicto de fechas'}: ${titulo}${textoObjetivos}`;
                
                    setScheduleError(mensajeError);
                    setIsLoading(false);
                    return; // Se detiene sin activar Snackbar de éxito
                }
        
                // 2. Crear el mantenimiento
                const isSuccess = await createMaintenance(
                    user,
                    nameUser,
                    token,
                    begin,
                    final,
                    comment,
                    titulo,
                    newObjetivos
                );
        
                if (!isSuccess) {
                    setScheduleError(t('schedule.errors.creation_failed') || 'Error al guardar el agendamiento.');
                    
                    // Activar Snackbar de error
                    setCheck(false);
                    setLoadModal(true);
                    setIsLoading(false);
                    return;
                }
            }
        
            // --- ÉXITO TOTAL ---
            setStoredEvents([]);
            setScheduleModalOpen(false);
            
            // Activar Snackbar de éxito
            setCheck(true);
            setLoadModal(true);
            
            processData();
        } catch (error) {
            console.error("Error al procesar el agendamiento:", error);
            setScheduleError("Error al conectar con el servidor.");
            
            // Activar Snackbar de error
            setCheck(false);
            setLoadModal(true);
        } finally {
            setIsLoading(false);
        }
    };

    {/* Calculamos si hay algún campo obligatorio incompleto */}
    const isFormInvalid = storedEvents.some(
        (item) => !item.titulo?.trim() || !item.comentario?.trim()
    );

    return (
        <Box>
            <Box padding={2}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box marginBottom={2} display="flex" justifyContent="space-between" alignItems="center">
                            <Box>
                                <Box display="flex" alignItems="center">
                                    <UpdateIcon />
                                    <Typography style={{ fontWeight: "bold", marginLeft: 10 }}>
                                        {t('text.last-update')}: {lastUpdateFormat}
                                    </Typography>
                                </Box>
                                {autoRefresh && (
                                    <small style={{ fontSize: 12 }}>
                                        {t('general-status.text.auto-update')}
                                    </small>
                                )}
                            </Box>

                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={
                                    <Badge badgeContent={storedEvents.length} color="secondary">
                                        <EventNoteIcon />
                                    </Badge>
                                }
                                onClick={() => setScheduleModalOpen(true)}
                            >
                                {t('maintenance.tabs.schedule')}
                            </Button>
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6}>
                        <FilterTags
                            listObjectives={[]}
                            updateEtiquetas={(etiquetas, filterType = "OR") =>
                                updateEtiquetas(etiquetas, filterType)
                            }
                            tagsId={filterTagsId}
                            preload={true}
                            filterTagsType={filterTagsType}
                            showFilterType={true}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6}>
                        <Box display="flex" justifyContent="flex-end">
                            <Box display="flex">
                                <AtSelectPeriod
                                    persistInStorage={false}
                                    hideApplyToAll={true}
                                    changePeriodFn={changeGlobalPeriod}
                                    defaultPeriods={defaultPeriodsGeneralStatus}
                                    activePeriodFromParent={activePeriodState}
                                    customMaxDate={new Date()}
                                    limitDays={31}
                                />
                                <Tooltip title={t('text.fullscreen')}>
                                    <IconButton
                                        onClick={() => setDataModalFullscreen({ fullScreenEl: true })}
                                    >
                                        <FullscreenIcon />
                                    </IconButton>
                                </Tooltip>
                                <IconButton onClick={(e) => setConfigEl(e.currentTarget)}>
                                    <SettingsOutlinedIcon />
                                </IconButton>
                            </Box>
                            <ConfigPopover
                                el={configEl}
                                handleRefresh={() => processData()}
                                handleClose={() => setConfigEl(null)}
                                autoRefresh={Boolean(autoRefresh)}
                                handleChangeAutoRefresh={handleChangeAutoRefresh}
                            />
                        </Box>
                        <Box display='flex' alignItems='center' justifyContent='flex-end'>
                            <Typography variant='h6' style={{ color: "#6b6b6b" }}>
                                {isGlobal ? t('general-status.text.global-general-status') : t('general-status.text.special-general-status')}
                            </Typography>
                            <Box style={{ marginLeft: '10px', marginRight: '10px' }}>
                                <Switch
                                    checked={isSpecial}
                                    onChange={handleChangeSwitch}
                                    color='primary'
                                />
                            </Box>
                        </Box>
                    </Grid>
                </Grid>

                {isLoading && (
                    <Box marginBottom={2}>
                        <LinearProgress />
                    </Box>
                )}

                {!isLoading && graphData?.categories.length === 0 && (
                    <Alert style={{ marginBottom: 10 }} severity="warning">
                        {t('general-status.alert.message.no-objectives')}
                    </Alert>
                )}

                {graphData && (
                    <Alert severity="info" style={{ width: "100%" }}>
                        {t('general-status.alert.message')}
                    </Alert>
                )}

                {graphData?.categories.length > 0 && !isLoading && (
                    <Box style={{ display: "flex", justifyContent: "center" }}>
                        <Box marginTop={2} sx={{ minWidth: "80vw", maxWidth: "80vw" }}>
                            <ObjectiveZoomGraph
                                categories={graphData.categories}
                                series={graphData.series}
                                openModal={openModal}
                                onSelectEvent={handleSelectEvent}
                            />
                        </Box>
                    </Box>
                )}
            </Box>

            <Dialog
                open={dataModal.open}
                onClose={handleCloseModal}
                maxWidth={"lg"}
                fullWidth={true}
            >
                {objectivesListData && (
                    <ListObjectiveModal
                        obj={dataModal.objId}
                        objName={dataModal.objNameModal}
                        listObjectives={objectivesListData}
                        handleClose={handleCloseModal}
                    />
                )}
            </Dialog>

            {/* Modal Pantalla Completa */}
            <Dialog
                fullScreen
                open={dataModalFullscreen.fullScreenEl}
                onClose={handleCloseFullScreen}
                container={() => document.body}
                PaperProps={{
                    style: {
                        margin: 0,
                        padding: 0,
                        width: '100vw',
                        height: '100vh',
                        maxWidth: '100vw',
                        maxHeight: '100vh',
                        borderRadius: 0
                    }
                }}
            >
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '4px 12px',
                    backgroundColor: '#0b1738',
                    color: '#fff',
                    height: '40px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <img
                            alt="Atentus logo"
                            style={{ height: 45 }}
                            src={"/images/logos/atentus-isotipo.svg"}
                        />
                        <Typography variant="h3" style={{ color: '#fff' }}>
                            {t('dashboard-layout.title.general-status')}
                        </Typography>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <Typography variant="h6">
                            {email}
                        </Typography>
                        <IconButton onClick={handleCloseFullScreen} style={{ color: '#fff', padding: 4 }}>
                            <ClearIcon />
                        </IconButton>
                    </div>
                </div>

                <div style={{
                    padding: 0,
                    margin: 0,
                    height: 'calc(100vh - 40px)',
                    width: '100%',
                    overflow: 'auto', // Cambiado a 'auto' por si la alerta o loader ocupan espacio
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    {/* 1. Indicador de carga durante auto-refresh */}
                    {isLoading && (
                        <Box width="100%">
                            <LinearProgress />
                        </Box>
                    )}

                    {/* 2. Mensaje si la carga terminó y no hay categorías */}
                    {!isLoading && graphData?.categories?.length === 0 && (
                        <Box padding={2}>
                            <Alert severity="warning">
                                {t('general-status.alert.message.no-objectives')}
                            </Alert>
                        </Box>
                    )}

                    {/* 3. Renderizar gráfico si hay datos (independientemente de si está recargando en background) */}
                    {graphData?.categories?.length > 0 && (
                        <Box style={{ display: "flex", justifyContent: "center" }}>
                            <Box marginTop={2} sx={{ minWidth: "80vw", maxWidth: "80vw" }}>
                                <ObjectiveZoomGraph
                                    categories={graphData.categories}
                                    series={graphData.series}
                                    openModal={openModal}
                                    onSelectEvent={handleSelectEvent}
                                />
                            </Box>
                        </Box>
                    )}
                </div>
            </Dialog>

            {/* DIÁLOGO DE CONFIRMACIÓN */}
            <Dialog open={confirmDialogOpen} onClose={handleCancelSelection}>
                <DialogTitle>{t('general-status.add.event.dialog.title')}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                    {t('general-status.add.event.dialog.content')} <strong>{pendingEventData?.objetivos?.map(obj => obj.nombre).join(", ")}</strong>?
                        <br /><br />
                        - <strong>{t('general-status.add.event.dialog.status')}</strong> {pendingEventData?.estado}<br />
                        - <strong>{t('general-status.add.event.dialog.begin')}</strong> {pendingEventData?.fechaInicio && moment.utc(pendingEventData.fechaInicio).format("DD/MM/YYYY HH:mm:ss")}<br />
                        - <strong>{t('general-status.add.event.dialog.end')}</strong> {pendingEventData?.fechaFin && moment.utc(pendingEventData.fechaFin).format("DD/MM/YYYY HH:mm:ss")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelSelection} color="secondary">
                        {t('general-status.add.event.dialog.button.no')}
                    </Button>
                    <Button onClick={handleConfirmSelection} color="primary" variant="contained" autoFocus>
                        {t('general-status.add.event.dialog.button.yes')}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* MODAL AGENDAR MULTIOBJETIVO */}
            <Dialog 
                open={scheduleModalOpen} 
                onClose={() => {
                    setScheduleModalOpen(false);
                    setScheduleError(null);
                }}
                maxWidth="xl"
                fullWidth
            >
                <DialogTitle>{t('general-status.form.maintenance.dialog.title')}({storedEvents.length})</DialogTitle>
                <DialogContent>
                    {/* Despliegue de error internacionalizado */}
                    {scheduleError && (
                        <Alert 
                            severity="error" 
                            onClose={() => setScheduleError(null)} 
                            style={{ marginBottom: 16 }}
                        >
                            {scheduleError}
                        </Alert>
                    )}
                    {storedEvents.length === 0 ? (
                        <Alert severity="info">
                            {t('general-status.form.maintenance.dialog.no-event')}
                        </Alert>
                    ) : (
                        <TableContainer component={Paper} variant="outlined">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        {/* Columnas con indicador de obligatorio (*) */}
                                        <TableCell style={{ minWidth: 180 }}>
                                            <strong>{t('general-status.form.maintenance.dialog.cells.title')} *</strong>
                                        </TableCell>
                                        <TableCell style={{ minWidth: 220 }}>
                                            <strong>{t('general-status.form.maintenance.dialog.cells.objectives')}</strong>
                                        </TableCell>
                                        <TableCell style={{ minWidth: 220 }}>
                                            <strong>{t('general-status.form.maintenance.dialog.cells.comment')} *</strong>
                                        </TableCell>
                                        <TableCell><strong>{t('general-status.form.maintenance.dialog.cells.status')}</strong></TableCell>
                                        <TableCell><strong>{t('general-status.form.maintenance.dialog.cells.begin')}</strong></TableCell>
                                        <TableCell><strong>{t('general-status.form.maintenance.dialog.cells.end')}</strong></TableCell>
                                        <TableCell align="center"><strong>{t('general-status.form.maintenance.dialog.cells.action')}</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {storedEvents.map((item) => {
                                        const isTitleEmpty = !item.titulo?.trim();
                                        const isCommentEmpty = !item.comentario?.trim();

                                        return (
                                            <TableRow key={item.id}>
                                                {/* Campo Título Obligatorio */}
                                                <TableCell>
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        required
                                                        variant="outlined"
                                                        placeholder={t('general-status.form.maintenance.dialog.cells.placeholder.title')}
                                                        value={item.titulo || ''}
                                                        onChange={(e) => handleFieldChangeForEvent(item.id, 'titulo', e.target.value)}
                                                        error={isTitleEmpty}
                                                        helperText={isTitleEmpty ? t('Campo requerido') : ''}
                                                    />
                                                </TableCell>

                                                {/* Campo Objetivos */}
                                                <TableCell>
                                                    <FormControl fullWidth size="small">
                                                        <Select
                                                            multiple
                                                            value={item.objetivos || []}
                                                            onChange={(e) => handleObjectivesChangeForEvent(item.id, e.target.value)}
                                                            renderValue={(selected) => (
                                                                <Box display="flex" flexWrap="wrap" style={{ gap: 4 }}>
                                                                    {selected.map((obj, index) => (
                                                                        <Chip
                                                                            key={obj.objetivo_id || obj.nombre || index}
                                                                            label={obj.nombre}
                                                                            size="small"
                                                                            color="primary"
                                                                            variant="outlined"
                                                                        />
                                                                    ))}
                                                                </Box>
                                                            )}
                                                        >
                                                            {availableObjectivesList.map((obj) => {
                                                                const isChecked = (item.objetivos || []).some(
                                                                    (selected) =>
                                                                        (selected.objetivo_id && selected.objetivo_id === obj.objetivo_id) ||
                                                                        selected.nombre === obj.nombre
                                                                );

                                                                return (
                                                                    <MenuItem key={obj.objetivo_id || obj.nombre} value={obj}>
                                                                        <Checkbox checked={isChecked} />
                                                                        <ListItemText primary={obj.nombre} />
                                                                    </MenuItem>
                                                                );
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                </TableCell>

                                                {/* Campo Comentario Obligatorio */}
                                                <TableCell>
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        required
                                                        multiline
                                                        minRows={1}
                                                        maxRows={3}
                                                        variant="outlined"
                                                        placeholder={t('general-status.form.maintenance.dialog.cells.placeholder.comment')}
                                                        value={item.comentario || ''}
                                                        onChange={(e) => handleFieldChangeForEvent(item.id, 'comentario', e.target.value)}
                                                        error={isCommentEmpty}
                                                        helperText={isCommentEmpty ? t('Campo requerido') : ''}
                                                    />
                                                </TableCell>

                                                <TableCell>{item.estado}</TableCell>
                                                <TableCell>{moment.utc(item.fechaInicio).format("DD/MM/YYYY HH:mm:ss")}</TableCell>
                                                <TableCell>{moment.utc(item.fechaFin).format("DD/MM/YYYY HH:mm:ss")}</TableCell>
                                                <TableCell align="center">
                                                    <IconButton 
                                                        color="secondary" 
                                                        size="small"
                                                        onClick={() => handleDeleteStoredEvent(item.id)}
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button 
                        onClick={() => setScheduleModalOpen(false)} 
                        color="default"
                        disabled={isLoading}
                    >
                        {t('general-status.form.maintenance.dialog.button.close')}
                    </Button>
                    <Button 
                        disabled={storedEvents.length === 0 || isLoading || isFormInvalid}
                        onClick={handleProcessSchedule} 
                        color="primary" 
                        variant="contained"
                    >
                        {isLoading ? t('general-status.form.maintenance.dialog.button.processing') : t('general-status.form.maintenance.dialog.button.schedule')}
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Notificaciones */}
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={loadModal}
                autoHideDuration={5000}
                onClose={handleClose}
            >
                {check ? (
                    <Alert
                        onClose={handleClose}
                        severity="success"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {t ? t('schedule.modal.success') : 'Mantenimiento ingresado con exito'}
                    </Alert>
                ) : (
                    <Alert
                        onClose={handleClose}
                        severity="error"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {t ? t('schedule.modal.error') : 'Ha ocurrido un error, intente nuevamente'}
                    </Alert>
                )}
            </Snackbar>
        </Box>
    );
}

export default withRouter(PanelAvailabilityCopy);